import { TCMSystemConfiguration, TCMSystemConfigurationService } from "@nt-portal/tcm-sdk";
import { BaseClientService } from "../../base-client.service";




export class TCMClientSystemSettingsService extends BaseClientService {

    private _service: TCMSystemConfigurationService;

    constructor() {
        super();
        this._service = new TCMSystemConfigurationService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }


    public async getClientSettings() {
        return await this._service.getClient(this.token);
    }

    public async get() {
        return await this._service.get(this.token);
    }

    public async save(item: TCMSystemConfiguration) {
        return await this._service.add(item, this.token,);
    }

    public async update(setting: TCMSystemConfiguration) {
        if (setting?.id)
        return await this._service.update(setting.id, setting, this.token);
    }

}